// extracted by mini-css-extract-plugin
module.exports = {"size":"background_size__PK3ax","background":"background_background__0L7au","gradient":"background_gradient__VLVqD"};